import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, OceanTag } from "./kit";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OceanUpdatesPreview() {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    axios.get(`${API}/ocean/updates`).then((r) => setUpdates(r.data.slice(0, 3))).catch(() => setUpdates([]));
  }, []);

  return (
    <section id="journal" data-testid="ocean-updates-preview-section" className="relative py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <OceanTag index="09" label="Mission Updates & Field Journal" />
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
            <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-oseaglass leading-[0.95]">
              Concept notes <span className="text-oreef">from the surface</span>
            </h2>
            <Link to="/ocean/updates" data-testid="ocean-updates-view-all" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-oreef hover:text-oseaglass transition-colors shrink-0">
              View the full journal <ArrowUpRight size={15} />
            </Link>
          </div>
          <p className="mt-6 max-w-2xl text-sm text-oslate leading-relaxed font-mono tracking-wide">
            CLEARLY LABELLED CONCEPT NOTES UNTIL GENUINE FIELD OBSERVATIONS EXIST. NO FABRICATED SIGHTINGS, PHOTOGRAPHS OR DISCOVERIES.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {updates.map((u, i) => (
            <Reveal key={u.id} delay={0.06 * i}>
              <article className="h-full border border-oreef/15 bg-oabyss/40 p-7 hover:border-oreef/40 transition-colors duration-300" data-testid={`ocean-update-card-${i}`}>
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-[9px] tracking-[0.25em] text-ocoral border border-ocoral/30 px-2 py-1">{u.kind}</span>
                  <span className="font-mono text-[10px] text-oslate tracking-wider">{u.date}</span>
                </div>
                <div className="font-mono text-[10px] tracking-[0.2em] text-oreef mt-5">{u.category}</div>
                <h3 className="font-display font-semibold text-xl text-oseaglass mt-2 leading-tight tracking-wide">{u.title}</h3>
                <p className="mt-3 text-sm text-oseaglass/65 leading-relaxed">{u.summary}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
